import React from 'react';
import PropTypes from 'prop-types';

export default function DotsIcon({ size, color, ...rest }) {
  return (
    <svg height={size} viewBox="0 0 515.555 515.555" width={size} {...rest}>
      <path
        fill={color}
        d="m496.679 212.208c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138 65.971-25.167 91.138 0"
      />
      <path
        fill={color}
        d="m303.347 212.208c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138 65.971-25.167 91.138 0"
      />
      <path
        fill={color}
        d="m110.014 212.208c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138 65.971-25.167 91.138 0"
      />
    </svg>
  );
}

DotsIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

DotsIcon.defaultProps = {
  size: 15,
  color: '#000',
};
